import "./Project/globals";

import "object-fit-videos";
import "vanilla-lazyload";
import "lazyembed2";
import "jquery";
import "jquery-bridget";
import "popper.js";

/**
 * Cookie Consent
 */
import "cookieconsent/src/cookieconsent";

/**
 * Bootstrap
 */
import "bootstrap/js/src/util";
//import "bootstrap/js/src/alert";
//import "bootstrap/js/src/button";
//import "bootstrap/js/src/carousel";
import "bootstrap/js/src/collapse";
//import "bootstrap/js/src/dropdown";
//import "bootstrap/js/src/modal";
//import "bootstrap/js/src/scrollspy";
import "bootstrap/js/src/tab";
//import "bootstrap/js/src/tooltip";
//import "bootstrap/js/src/popover";

// /**
//  * Bootstrap Multiselect
//  */
// import "bootstrap-multiselect";

/**
 * Slick
 */
import "slick-carousel";

/**
 * Light Galery
 */
import "lightgallery";
import "lg-autoplay";
import "lg-fullscreen";
import "lg-hash";
import "lg-pager";
import "lg-share";
import "lg-thumbnail";
import "lg-video";
import "lg-zoom";

/**
 * Project
 */
import "./Project/viewport";
import "./Project/sizeChange";
import "./Project/pageLoaded";
import "./Project/objectFitVideos";
import "./Project/counter";
import "./Project/circleCounter";
import "./Project/cookieConsent";
import "./Project/downloadFilters";
import "./Project/lightGallery";
import "./Project/lazyload";
import "./Project/lazyEmbed";
import "./Project/slick";
